import { Seo } from "@/components/common/Seo";
import { Hero } from "@/components/home/Hero";
import { Marquee } from "@/components/home/Marquee";
import { Services } from "@/components/home/Services";
import { Solutions } from "@/components/home/Solutions";
import { Process } from "@/components/home/Process";
import { WhyQuantivo } from "@/components/home/WhyQuantivo";
import { Work } from "@/components/home/Work";
import { Faq } from "@/components/home/Faq";
import { FinalCta } from "@/components/home/FinalCta";

export default function Home() {
  return (
    <>
      <Seo path="/" title="Quantivo — Custom Software, SaaS & Automation Development"
        description="Quantivo builds SaaS products, custom software, web and mobile apps, business automation and payment API solutions for startups and growing businesses." />
      <Hero />
      <Marquee />
      <Services />
      <Solutions />
      <Process />
      <WhyQuantivo />
      <Work />
      <Faq />
      <FinalCta />
    </>
  );
}
